// Format a UTC ISO timestamp into a human-friendly "hace X" string in Spanish.
// Returns "Nunca" when value is falsy.
export function formatLastLogin(iso) {
  if (!iso) return 'Nunca';
  const then = new Date(iso);
  if (isNaN(then.getTime())) return 'Nunca';
  const seconds = Math.max(0, Math.floor((Date.now() - then.getTime()) / 1000));
  if (seconds < 60) return 'Hace unos segundos';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `Hace ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Hace ${hours} h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `Hace ${days} d`;
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `Hace ${weeks} sem`;
  const months = Math.floor(days / 30);
  if (months < 12) return `Hace ${months} mes${months === 1 ? '' : 'es'}`;
  const years = Math.floor(days / 365);
  return `Hace ${years} año${years === 1 ? '' : 's'}`;
}

// Returns a tailwind color class based on recency.
export function getLastLoginColor(iso) {
  if (!iso) return 'text-slate-400';
  const days = (Date.now() - new Date(iso).getTime()) / (1000 * 60 * 60 * 24);
  if (days < 1) return 'text-emerald-600';
  if (days < 7) return 'text-blue-600';
  if (days < 30) return 'text-amber-600';
  return 'text-slate-500';
}
